import React from 'react';
import { SwitchOrganizationView, SwitchOrganizationViewProps } from './SwitchOrganization.view';
import { useUserData } from '../../../hooks/useUserData';
import { GetMe_me_organizations } from '../../../models/legacy-graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

import { changeSelectedWorkspaceId } from '../../../providers/AppProvider';

export type MappedOrganization = {
  name: string;
  id: string;
  workspaceId: string;
};

export const SwitchOrganizationController = (): JSX.Element => {
  // Put All your methods and logic here
  const { userData, loading, error } = useUserData();

  const organizations: MappedOrganization[] | undefined = userData?.organizations.map<MappedOrganization>(
    (organization: GetMe_me_organizations) => ({
      name: organization.name,
      id: organization.id,
      workspaceId: (organization.workspaces.length && organization.workspaces[0].id) || ''
    })
  );

  const switchOrganizationAction = (workspaceId: string): void => {
    changeSelectedWorkspaceId(workspaceId, '/');
  };

  const userError: JSX.Element | string = error ? remapApolloErrors(error) : '';

  const viewProps: SwitchOrganizationViewProps = {
    loading,
    organizations,
    switchOrganizationAction,
    userError
  };
  return <SwitchOrganizationView {...viewProps} />;
};
